import WhiteHeader from './App';
import Vuex from 'vuex';
import { MOUNT_POINT_ID } from './constants';

export default function createApp({
  Vue,
  vuexStore,
  USER = {},
  appMountedCallback = function () {},
  originalUrl = '',
  canUseWebp = false,
}) {
  Vue.use(Vuex);

  const store = vuexStore;

  const app = new Vue({
    store,
    components: {
      WhiteHeader,
    },
    data() {
      return {
        isLoggedIn: USER ? !!USER.id : false,
        appMountedCallback,
        originalUrl,
        canUseWebp,
      };
    },
    template: `<div id="${MOUNT_POINT_ID}"><white-header :is-logged-in="isLoggedIn" :original-url="originalUrl"></white-header></div>`,
  });

  return { app, store };
}
